// app/providers/SidebarClickProvider.jsx
'use client';

import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { setSideBar } from '@/store/slices/sidebarSlice';

const SidebarClickProvider = ({ children }) => {
  const dispatch = useAppDispatch();
  const isMenuOpen = useAppSelector((state) => state.sideBar.isOpen);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click is outside both sidebar and menu button
      const sidebarElement = document.querySelector('[data-sidebar="true"]');
      const isMenuButtonClick = event.target.closest('[data-menu-button="true"]');

      if (
        isMenuOpen &&
        sidebarElement &&
        !sidebarElement.contains(event.target) &&
        !isMenuButtonClick
      ) {
        dispatch(setSideBar({ isOpen: false }));
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen, dispatch]);

  return children;
};

export default SidebarClickProvider;
